// removed by extract-text-webpack-plugin
module.exports = {"campaignOtpInputContainer":"campaignOtpInputContainer__1bsD6","otpInputBox":"otpInputBox__13tii","otpSubmitButton":"otpSubmitButton__1_VZ0"};


//////////////////
// WEBPACK FOOTER
// ./routes/campaign-fast-feature/components/otp-input/style.css
// module id = VeEV
// module chunks = 444